document.addEventListener('submit', async function(event) {
    if (event.target && event.target.id === 'omgrfq-quote-list-form') {
        const quoteForm = event.target;
        console.log('Form with id "omgrfq-quote-list-form" was submitted.');
        const formData = new FormData(quoteForm);
        console.log(formData);

        const data = {};
        formData.forEach((value, key) => {
            data[key] = value;
        });

        let productRows = quoteForm.querySelectorAll('.omgrfq-table .omgrfq_product_row');
        let products = [];

        // Iterate over each product row to get product name and SKU
        productRows.forEach((row) => {
            let productNameElement = row.querySelector('a.omgrfq-product-link--processed');
            let productSkuElement = row.querySelector('.omgrfq_product_title-wrapper p');

            let productName = productNameElement ? productNameElement.innerText.trim() : '';
            let productSku = productSkuElement ? productSkuElement.innerText.trim() : '';

            if (productName || productSku) {
                products.push(`${productName} (${productSku})`);
            }
        });

        // Create a comma-separated list of product details
        let productDetailsString = products.join(', ');

        data["omgrfq-form_product_name"] = productDetailsString;

        let webhookUrl = "https://hook.us2.make.com/6l00gughwof1yl6zqfwd7w0us1afidiz";

        try {
            const response = await fetch(webhookUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                console.log("Your message has been sent successfully!");
            } else {
                console.log("There was a problem sending your message. Please try again.");
            }
        } catch (error) {
            console.error("Error posting form data: ", error);
            console.log("There was a problem sending your message. Please try again.");
        }
    }
});
